module.exports = __webpack_public_path__ + "static/backgroundIcons-29137cb47cb0b9095a7c71902f860ed9.png";